/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Scope_Output5Inputs */

const en_svc_ai_voice_agents_scope_output5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call handling contract`)
};

const ar_svc_ai_voice_agents_scope_output5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عقد معالجة المكالمات`)
};

const bn_svc_ai_voice_agents_scope_output5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কল পরিচালনা চুক্তি`)
};

const de_svc_ai_voice_agents_scope_output5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anrufbehandlungsvertrag`)
};

const es_svc_ai_voice_agents_scope_output5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrato de atención de llamadas`)
};

const fr_svc_ai_voice_agents_scope_output5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrat de traitement des appels`)
};

const pt_svc_ai_voice_agents_scope_output5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrato de atendimento de chamadas`)
};

const zh_svc_ai_voice_agents_scope_output5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通话处理合约`)
};

const tr_svc_ai_voice_agents_scope_output5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çağrı karşılama sözleşmesi`)
};

const ru_svc_ai_voice_agents_scope_output5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Договор обработки звонков`)
};

const pl_svc_ai_voice_agents_scope_output5 = /** @type {(inputs: Svc_Ai_Voice_Agents_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umowa obsługi połączeń`)
};

/**
* | output |
* | --- |
* | "Call handling contract" |
*
* @param {Svc_Ai_Voice_Agents_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_scope_output5 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_scope_output5(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_scope_output5(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_scope_output5(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_scope_output5(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_scope_output5(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_scope_output5(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_scope_output5(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_scope_output5(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_scope_output5(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_scope_output5(inputs)
	return en_svc_ai_voice_agents_scope_output5(inputs)
});
export { svc_ai_voice_agents_scope_output5 as "svc_ai-voice-agents_SCOPE_output" }